import moment from 'moment';

export const getFormatTime = ({ time, format }: {time: string | number, format?: string}) => {
    format = format || 'YYYY-MM-DD HH:mm'
    if (typeof time === 'number') {
        return moment(time).format(format)
    }
    const isNum = /^\d+$/.test(time)
    if (isNum) {
        return moment(Number(time)).format(format)
    }
    return moment(time).format(format)
}